import {FC} from 'react'
import {Link} from 'react-router-dom'
import {Subscriber} from '../ts/types-new'

interface Props {
    contacts: Subscriber[]
}

const ContactsDashboard: FC<Props> = ({contacts}) => {
    const colors = ['success', 'primary', 'info', 'warning', 'danger']

    return (
        <>
            <div className="card-header border-0">
                <h3 className="card-title fw-bolder text-dark">5 derniers contacts</h3>
            </div>
            <div className="card-body p-3">
                {
                    contacts.length
                        ? (
                            contacts.slice(0, 5).map((contact, index) => {
                                const {email, first_name, last_name, number, id} = contact

                                return (
                                    <div className="d-flex align-items-center mb-8" key={id}>
                                        <span className={`bullet bullet-vertical h-40px me-5 bg-${colors[index]}`}/>
                                        <div className="flex-grow-1">
                                            <Link to={`/contacts/modifier-contact/${id}`}
                                                  className="text-gray-800 text-hover-primary fw-bolder fs-7">
                                                {first_name} {last_name}
                                            </Link>
                                            <span className="text-muted fw-bold d-block fs-9">{email}</span>
                                        </div>
                                        <span
                                            className={`badge badge-light-${colors[index]} fs-9 fw-bolder`}>{number}</span>
                                    </div>
                                )
                            })
                        )
                        : <h4 className="text-gray-800 fs-6">La liste des 5 derniers contacts est vide</h4>
                }
            </div>
        </>
    )
}

export {ContactsDashboard}
